import { makeAutoObservable } from 'mobx'
import { type IResponseInbox } from 'entities/Inbox/api/types'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { MessagingGeneralStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/messaging/general/store/MessagingGeneralStore'
import { type InboxLayerStore } from 'pages/settings/pages/inboxes/pages/id/store/inboxLayerStore'
import { ConversationAssignmentStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/messaging/conversationAssignment/store/conversationAssignmentStore'
import { MessagingAiAutomationStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/messaging/ai-automation/store/MessagingAiAutomationStore'
import { BusinessHoursStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/messaging/businessHours/store/businessHours'
import { CallingGeneralStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/general/store/callingGeneralStore'
import { SmartInboxStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/messaging/smartInbox/store/smartInboxStore'

export class InboxSettingsStore {
  readonly messagingGeneralStore: MessagingGeneralStore
  readonly conversationAssignmentStore: ConversationAssignmentStore
  readonly messagingAiAutomationStore: MessagingAiAutomationStore
  readonly businessHoursStore: BusinessHoursStore
  readonly callingGeneralStore: CallingGeneralStore
  readonly smartInboxStore: SmartInboxStore

  constructor(private _inboxLayerStore: InboxLayerStore, private _entities: IEntitiesStore) {
    this.messagingGeneralStore = new MessagingGeneralStore(this, this._entities)
    this.conversationAssignmentStore = new ConversationAssignmentStore(this)
    this.messagingAiAutomationStore = new MessagingAiAutomationStore()
    this.businessHoursStore = new BusinessHoursStore(this, this._entities)
    this.callingGeneralStore = new CallingGeneralStore(this, this._entities)
    this.smartInboxStore = new SmartInboxStore(this._entities)

    makeAutoObservable(this)
  }

  init = (inbox: IResponseInbox) => {
    this.messagingGeneralStore.init(inbox)
    this.conversationAssignmentStore.init(inbox)
    this.messagingAiAutomationStore.init(inbox)
    this.businessHoursStore.init(inbox)
    this.callingGeneralStore.init(inbox)
    this.smartInboxStore.init(inbox)
  }

  get inbox() {
    return this._inboxLayerStore.currentTeam
  }

  get inboxId() {
    return this._inboxLayerStore.currentTeam?.id
  }

  get inboxLayerStore() {
    return this._inboxLayerStore
  }

  updateCurrentTeamName = (name: string) => {
    this._inboxLayerStore.updateCurrentTeamName(name)
  }

  dispose = () => {
    this.businessHoursStore.dispose()
  }
}
